var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('SecondStep',{attrs:{"selected-rows":_vm.selectedFields,"customColumnDefinition":_vm.customColumnDefinition,"customTableData":_vm.customTableData,"sumProcessedArea":_vm.sumProcessedArea},on:{"update:selectedRows":_vm.updateSelectedFields,"update:cell":_vm.updateCell}})
}
var staticRenderFns = []

export { render, staticRenderFns }